<template>
  <div
    class="image-input-wrapper rounded-circle"
    :style="imageStyle.backgroundImage ? imageStyle : defaultImage"
  ></div>
</template>

<script>
import { defineComponent, ref, toRefs, watch, onMounted, computed } from "vue";
import { v4 as uuidv4 } from "uuid";
import { FileAPI } from "@/services/api/File.service";
import { UserAPI } from "@/services/api/User.service";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default defineComponent({
  props: {
    selectedImage: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const { selectedImage } = toRefs(props);
    const imageStyle = ref({});
    const defaultImage = ref({
      backgroundImage: "url(media/misc/user-profile.svg)",
    });
    const store = useStore();
    const toast = useToast();
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });
    onMounted(() => {
      if (currentUser.value.webId) {
        getImageData();
      }
    });
    const getImageData = async () => {
      if (!currentUser.value.fileId) {
        return;
      }
      try {
        const response = await FileAPI.getInstance().fetchImageWithMetaData(
          currentUser.value.fileId
        );
        if (response) {
          const { data } = response;
          const imgWithRedirect = Buffer.from(data, "binary").toString();
          let decodeData = JSON.parse(imgWithRedirect);
          if (!decodeData.deleted) {
            imageStyle.value = {
              backgroundImage: `url(${decodeData.fileUrl})`,
            };
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        //
      }
    };
    watch(selectedImage, () => {
      handleImageChange();
    });
    watch(currentUser, () => {
      getImageData();
    });
    const handleImageChange = () => {
      if (selectedImage.value) {
        imageStyle.value = {
          backgroundImage: `url(${URL.createObjectURL(
            selectedImage.value.target.files[0]
          )})`,
        };
        const file = selectedImage.value.target.files[0];
        const fileName = selectedImage.value.target.files[0].name;
        const id = uuidv4();
        const data = {
          id,
          ownerWebId: currentUser.value.webId,
          name: fileName,
        };
        FileAPI.getInstance()
          .uploadFile(file, data)
          .then((response) => {
            if (response.status === 200) {
              toast.success("Profile picture added successfully");
            }
            const fileId = {
              fileId: response.data.id,
            };
            const data = UserAPI.getInstance().updateUserFileId(
              currentUser.value.webId,
              fileId
            );
          })
          .catch((error) => {
            //
          })
          .finally(() => {
            //
          });
      } else {
        imageStyle.value = {};
      }
    };
    return {
      imageStyle,
      handleImageChange,
      defaultImage,
    };
  },
});
</script>
